"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

var _lodash = _interopRequireDefault(require("lodash.groupby"));

var _reactHotLoader = require("react-hot-loader");

var _reactHelmet = _interopRequireDefault(require("react-helmet"));

var _reactRouterDom = require("react-router-dom");

var _Equip = _interopRequireDefault(require("../../../components/Equip"));

var _Loading = _interopRequireDefault(require("../../../components/Loading"));

var _Page = require("../../../components/Layout/Page");

var _storage = require("../../../utils/storage");

var _columns = require("../../../utils/columns");

var _routes = require("../../../utils/routes");

var _navigate = require("../../../utils/routes/navigate");

var _insights = require("../../../context/insights");

var _NoResultsOverlay = _interopRequireDefault(require("../../../components/NoResultsOverlay"));

/* eslint-disable no-eq-null */
const DEFAULT_SORT = {
  option: _columns.equipColumns.TRIGGERED_RULES.key,
  direction: _columns.equipColumns.TRIGGERED_RULES.sortDirection
};
const PERSIST_KEY = 'equipGrid';
const PERSIST_PROP = 'Equip-colSort';

const InsightEquips = props => {
  // check if the user has the site selected in the account
  if (props.userSites.sites[props.match.params.syncoId] === undefined) {
    return /*#__PURE__*/React.createElement(_reactRouterDom.Redirect, {
      to: "/404"
    });
  }

  const initialSort = React.useMemo(() => (0, _storage.getPersisted)({
    key: PERSIST_KEY,
    prop: PERSIST_PROP
  }, DEFAULT_SORT), []);
  const [sort, setSort] = React.useState(initialSort);
  const selectedSitesRef = React.useRef(JSON.stringify(props.selectedSites));
  const [state] = (0, _insights.useInsights)();
  React.useEffect(() => {
    props.setMultiSite(props.match.params.syncoId);
  }, []); // * If selected sites changes, navigate back to insights

  React.useEffect(() => {
    if (selectedSitesRef.current !== JSON.stringify(props.selectedSites)) {
      props.setShouldRequest(true);
      (0, _navigate.navigate)(props.urlHistory.insightsHistory.pathname)();
    }
  }, [props.selectedSites]); // Grid sort direction

  const handleSort = React.useCallback(option => () => {
    setSort(state => {
      const direction = state.direction === 'asc' ? 'desc' : 'asc';
      (0, _storage.setPersisted)({
        key: PERSIST_KEY,
        prop: PERSIST_PROP
      }, {
        option,
        direction
      });
      return {
        option,
        direction
      };
    });
  }, []);
  const occurencesForSite = state.composedOccurrencesBySite[props.match.params.syncoId];
  const occurencesForSiteAndRule = occurencesForSite === null || occurencesForSite === void 0 ? void 0 : occurencesForSite.filter(rule => rule.ruleId.toString() === props.match.params.ruleId);

  if (occurencesForSite != null && occurencesForSiteAndRule.length === 0) {
    return /*#__PURE__*/React.createElement(_Page.Wrap, null, /*#__PURE__*/React.createElement(_NoResultsOverlay.default, {
      noInsightsMessage: true
    }));
  } // * NOTE: Checking against the data instead of state.loading
  // * as loading can mean more than just whether the data is available
  // * This way, updates to snoozed/associated don't flash the loading spinner
  // * Instead, the updated data will just appear (same as how monitoring works)
  // ! TODO: Create a 'no results' variation to account for invalid site ids


  if (!state.composedOccurrencesBySite[props.match.params.syncoId]) return /*#__PURE__*/React.createElement(_Loading.default, null);
  const siteGroup = state.composedOccurrencesBySite[props.match.params.syncoId];
  const ruleGroup = (0, _lodash.default)(siteGroup, s => s.ruleId)[props.match.params.ruleId];
  if (ruleGroup === undefined) return /*#__PURE__*/React.createElement(_Page.Wrap, null, /*#__PURE__*/React.createElement(_NoResultsOverlay.default, {
    noResultsMessage: true
  }));
  const {
    ruleName,
    ruleDescription
  } = ruleGroup[0];
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(_reactHelmet.default, {
    title: `Insight - ${ruleName}`
  }), /*#__PURE__*/React.createElement(_Page.Wrap, {
    className: "Insights-EquipScene"
  }, /*#__PURE__*/React.createElement(_Equip.default, {
    insightType: _routes.InsightType.Insights,
    hits: ruleGroup,
    ruleName: ruleName,
    ruleDescription: ruleDescription,
    userDisplayName: props.userDisplayName,
    syncoId: props.match.params.syncoId,
    activeSite: props.match.params.syncoId,
    ruleId: props.match.params.ruleId,
    showSnoozed: props.showSnoozed,
    sortOption: sort.option,
    sortDirection: sort.direction,
    updateSort: handleSort,
    showModal: props.showModal,
    urlHistory: props.urlHistory,
    selectedSites: props.selectedSites
  })));
};

var _default = (0, _reactHotLoader.hot)(module)(InsightEquips);

exports.default = _default;
module.exports = exports.default;